import { useEffect, useState, useCallback } from "react";

const API = "https://www.d-rosa.ai";   // your Flask base URL (use http://localhost:5000 for testing)

export default function PlcPanel() {
  const [connected, setConnected] = useState(false);
  const [outputs, setOutputs] = useState(Array(8).fill(false)); // Y0-Y7
  const [regIndex, setRegIndex] = useState(0);
  const [regValue, setRegValue] = useState("");
  const [regRead, setRegRead] = useState(null);
  const [msg, setMsg] = useState("");

  const refresh = useCallback(async () => {
    try {
      const s = await (await fetch(`${API}/plc/status`)).json();
      setConnected(!!s.connected);
      if (s.connected) {
        const r = await (await fetch(`${API}/plc/coil/read?type=Y&index=0&count=8`)).json();
        if (r.success) setOutputs(r.values);
      }
    } catch {
      setConnected(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 2000);
    return () => clearInterval(t);
  }, [refresh]);

  const toggleY = async (i) => {
    const res = await fetch(`${API}/plc/coil/write`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: "Y", index: i, value: !outputs[i] }),
    });
    const d = await res.json();
    setMsg(d.success ? `Y${i} ${!outputs[i] ? "ON" : "OFF"}` : d.message);
    refresh();
  };

  const writeReg = async () => {
    const res = await fetch(`${API}/plc/register/write`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ index: Number(regIndex), value: Number(regValue) }),
    });
    const d = await res.json();
    setMsg(d.success ? `D${regIndex} = ${regValue}` : d.message);
  };

  const readReg = async () => {
    const d = await (await fetch(`${API}/plc/register/read?index=${regIndex}&count=1`)).json();
    if (d.success) setRegRead(d.values[0]);
    else setMsg(d.message);
  };

  return (
    <div style={{ padding: 20, maxWidth: 420 }}>
      <h2>Delta PLC Control</h2>
      <p>
        Status:{" "}
        <b style={{ color: connected ? "green" : "red" }}>
          {connected ? "Connected" : "Disconnected"}
        </b>
      </p>

      <h3>Outputs (Y0�Y7)</h3>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {outputs.map((on, i) => (
          <button
            key={i}
            disabled={!connected}
            onClick={() => toggleY(i)}
            style={{
              padding: "10px 14px",
              background: on ? "#22c55e" : "#e5e7eb",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Y{i}: {on ? "ON" : "OFF"}
          </button>
        ))}
      </div>

      <h3>Data Register (D)</h3>
      <input type="number" value={regIndex} onChange={(e) => setRegIndex(e.target.value)}
             placeholder="D index" style={{ width: 80, marginRight: 8 }} />
      <input type="number" value={regValue} onChange={(e) => setRegValue(e.target.value)}
             placeholder="value" style={{ width: 100, marginRight: 8 }} />
      <button onClick={writeReg} disabled={!connected}>Write</button>{" "}
      <button onClick={readReg} disabled={!connected}>Read</button>
      {regRead !== null && <p>D{regIndex} = <b>{regRead}</b></p>}

      {msg && <p style={{ color: "#555" }}>{msg}</p>}
    </div>
  );
}